import moment from 'moment'
import api from '../api'
import { fetchRecentActivities, updateRecentActivities } from './recentActivities'
import { fetchSetPolls } from './polls'
import { fetchLibraryPair } from './libraryHelpers'
import store from '../store'

const MINIMUM_TIME_BETWEEN_REFRESHES = 1000 * 60 // 60seconds

// state.sets holds the union of these two requests. Both derive their expected count
// from the same URL they load from, so the count always matches the filters applied.
const SETS_URLS = {
  own: '/sets?archived=false&sort=modified&parentArchived=false',
  allRepos: '/sets?allRepos=true&archived=false&sort=modified&parentArchived=false',
}

function loadSets(dispatch, modifiedAfter) {
  fetchLibraryPair(dispatch, {
    collection: 'sets',
    urls: SETS_URLS,
    successType: modifiedAfter ? 'REFRESH_SETS_SUCCESS' : 'FETCH_SETS_SUCCESS',
    modifiedAfter,
  })
}

export function fetchSets() {
  const state = store.getState()
  if (state.setsRefreshedTimestamp) { // if have previously fetched sets check the timestamp of last fetch. Only fetch if was more than MINIMUM_TIME_BETWEEN_REFRESHES ago
    const nowDate = moment()
    const timeSinceLastRefresh = nowDate - moment(state.setsRefreshedTimestamp)
    if (timeSinceLastRefresh > MINIMUM_TIME_BETWEEN_REFRESHES) {
      return (dispatch) => {
        loadSets(dispatch, state.setsRefreshedTimestamp)
      }
    }
    return ({ type: 'WAIT_TO_REFRESH' })
  }
  return (dispatch) => {
    loadSets(dispatch)
  }
}

export function fetchSetsNoMinTime() { // TODO clean this up
  const state = store.getState()
  if (state.setsRefreshedTimestamp) {
    return (dispatch) => {
      loadSets(dispatch, state.setsRefreshedTimestamp)
    }
  }
  return (dispatch) => {
    loadSets(dispatch)
  }
}

export function fetchSetsPreview() {
  return (dispatch) => api.fetch('/sets/preview')
    .then((response) => {
      dispatch({ type: 'FETCH_SETS_PREVIEW_SUCCESS', response })
    })
    .catch(() => {})
}

export function fetchSetsForRepo(repoId) {
  return (dispatch) => api.batchedFetch(`/sets?archived=false&sort=modified&parentArchived=false&repo=${repoId}`)
    .then((response) => {
      dispatch({ type: 'FETCH_REPO_SETS_SUCCESS', response })
    })
    .catch(() => {})
}

export function refetchSets() { // for after connecting to ISBE when modified query wont work
  return (dispatch) => {
    api.batchedFetch('/sets?&archived=false&sort=modified&parentArchived=false')
      .then((response) => {
        dispatch({ type: 'FETCH_SETS_SUCCESS', response })
      })
      .catch(() => {})
    api.batchedFetch('/sets?allRepos=true&archived=false&sort=modified&parentArchived=false')
      .then((response) => {
        dispatch({ type: 'FETCH_SETS_SUCCESS', response })
      })
      .catch(() => {})
  }
}

export function fetchArchivedSets() {
  return (dispatch) => {
    api.batchedFetch('/sets?archived=true&parentArchived=false&sort=modified')
      .then((response) => {
        dispatch({ type: 'FETCH_ARCHIVED_SETS_SUCCESS', response })
      })
      .catch(() => {})

    api.batchedFetch('/sets?allRepos=true&archived=true&parentArchived=false&sort=modified')
      .then((response) => {
        dispatch({ type: 'FETCH_ARCHIVED_SETS_SUCCESS', response })
      })
      .catch(() => {})
  }
}

export function fetchArchivedSetsForRepo(repoId) {
  return (dispatch) => api.batchedFetch(`/sets?archived=true&parentArchived=false&sort=modified&repo=${repoId}`)
    .then((response) => {
      dispatch({ type: 'FETCH_ARCHIVED_SETS_SUCCESS', response })
    })
    .catch(() => {})
}

export function fetchASet(setId) {
  const state = store.getState()
  if (state.requestedSets[setId]) {
    return ({ type: 'WAIT_TO_REFRESH' })
  }
  return (dispatch) => {
    dispatch({ type: 'FETCH_SET_REQUEST', setId })
    api.fetch(`/sets/${setId}`)
      .then((response) => {
        dispatch({ type: 'FETCH_A_SET_SUCCESS', response })
        return response
      })
      .catch(() => {})
  }
}

export function createNewSet(data) {
  if (typeof data.folder !== 'string') { // Prevent invalid folder value
    data.folder = null
  }
  data.lastEditedAt = data.clientModified
  return (dispatch) => api.post('/sets/', data)
    .then((set) => {
      dispatch({ type: 'CREATE_SET_SUCCESS', set, syncAction: true })
      dispatch(updateRecentActivities(set.id, 'set', 'create'))
      return set
    })
}

export function deleteSet(setId) {
  return (dispatch) => api.delete(`/sets/${setId}`)
    .then((response) => {
      dispatch({ type: 'DELETE_SET_SUCCESS', setId, syncAction: true })
      dispatch(fetchSetPolls())
      dispatch(fetchRecentActivities())
      return response
    })
    .catch(() => 'failed')
}

export function updateSetContent(data, setId) { // update set name or questions
  data.lastEditedAt = data.clientModified
  return (dispatch) => api.put(`/sets/${setId}/content`, data)
    .then((response) => {
      dispatch({ type: 'UPDATE_SET_SUCCESS', response, syncAction: true })
      if (!data.archived && setId) {
        dispatch(updateRecentActivities(setId, 'set', 'edit'))
      }
      return response
    })
    .catch(() => 'failed')
}

export function updateSetMeta(data, setId) { // update folder,repo or archived
  if (typeof data.folder !== 'string') { // Prevent invalid folder value
    data.folder = null
  }
  return (dispatch) => api.put(`/sets/${setId}/meta`, data)
    .then((response) => {
      dispatch({ type: 'UPDATE_SET_SUCCESS', response, syncAction: true })
      if (!data.archived) {
        dispatch(updateRecentActivities(setId, 'set', 'edit'))
      }
      return response
    })
    .catch(() => {

    })
}
